const state = {
  listInfo: JSON.parse(sessionStorage.getItem('listInfo')) || {
    obj_id: null,
  },
}
const getters = {
  listInfo: state => state.listInfo,
}
const actions = {
  listInfo({ commit }, payload) {
    commit('listInfo', payload)
    sessionStorage.setItem('listInfo', JSON.stringify(payload))
  },
}
const mutations = {
  listInfo(state, data) {
    state.listInfo = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
